import { z } from "zod";

export const zColorView = z.object({
  view: z.literal("ColorView"),
});

export type ZColorView = z.infer<typeof zColorView>;
